import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from 'utils/redux/useAppSelector';
/**
 * A hook that returns the current state of the Analytics page.
 *
 * The returned state is not exactly the same as what's in Redux. For instance,
 * the `context` object differs between dashboards and is therefore cached for
 * each dashboard. When accessing the state through this hook we only expose the
 * `context` corresponding to the currently loaded dashboard.
 */
export const useAnalyticsState = () => {
    const state = useAppSelector((state) => state.analytics, shallowEqual);
    // This hook is only called when a dashboard has been loaded, so we can safely use the non-null
    // assertion operator here to ensure that the dashboard is always defined.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const dashboard = state.dashboard;
    // Return only the context for the current dashboard.
    const context = state.context[dashboard.id];
    return useMemo(() => (Object.assign(Object.assign({}, state), { dashboard, context })), [context, dashboard, state]);
};
